// $( document ).ready(function() {
//   setTimeout(function() {
//     jQuery('.indexThumb a').click();
//     console.log("sss")
//    }, 1000);
// });



const dropdownBtn = document.getElementById("btnLang");
const dropdownMenu = document.querySelector(".dropdownLangList");

// Toggle dropdown function
const toggleDropdown = function () {
  dropdownMenu.classList.toggle("show");
};

// Toggle dropdown open/close when dropdown button is clicked
dropdownBtn.addEventListener("click", function (e) {
  e.stopPropagation();
  toggleDropdown();
});

// Close dropdown when dom element is clicked
document.documentElement.addEventListener("click", function () {
  if (dropdownMenu.classList.contains("show")) {
    toggleDropdown();
  }
});




$(document).ready(function () {


  // $('.pr_thumbs_item').click(function(){
  //   var imgHeight = $('.imgWrapper img').height();
  //   setTimeout(function() {
  //       $('.primgSlider a').css('height',imgHeight,'px');
  //   }, 1000);
  //   console.log(imgHeight);
  // })
  
  setTimeout(function () {
    $(".collage-bundle-template .pr_photoes").css("opacity", "1");
  }, 1500);

  function cartItems() {
    jQuery(".cart-item .gitem-img").css("opacity", "0");

    if ($(".cart-item__details").length > 0) {
      setTimeout(function () {
        $(".cart-item__details").each(function () {
          let cartImage = $(this).find(".pr_vr._Image").text();
          if (cartImage) {
            // console.log("run2");
            var cartImgSrc = cartImage.replace("_Image:", "");
            $(this)
              .closest(".cart-item")
              .find(".gitem-img")
              .css("background-image", "url(" + cartImgSrc + ")");
          }
          $(this).closest(".cart-item").find(".gitem-img").css("opacity", "1");
        });
      }, 1500);
    }
  }
  // cartItems();
  $(document).on("click", "cart-remove-button, .header-cart", cartItems);
});

$(document).ready(function () {
  // fill pregress bar at cart page
  function updateValue() {
    setTimeout(function () {
      // var valueper = $('.progressVal').text();
      // $('.sunrise').attr('value', valueper);
      // console.log(valueper, 'click get value');
      jQuery(".progressFill").load(location.href + " .progressFill");
      jQuery(".progressFillContent").load(
        location.href + " .progressFillContent"
      );
    }, 1500);
  }
  $(document).on("click", ".cart__items .plus", function () {
    updateValue();
  });

  $(document).on("click", ".cart__items .minus", function () {
    updateValue();
  });

  $(document).on("click", ".cart__items .removeMb", function () {
    updateValue();
  });

  // scroll animation and add to cart button at mobile cart page
  $(window).resize(function () {
    if ($(window).width() < 767) {
      $(window).scroll(function () {
        var scroll = $(window).scrollTop();
        // console.log(scroll, "scroll");
        if (scroll >= 1) {
          $(".stickybtn").removeClass("mobstickybtn");
        } else {
          $(".stickybtn").addClass("mobstickybtn");
        }
      });
    }
  });

  $(window).resize(function () {
    if ($(window).width() < 600) {
      $(window).scroll(function () {
        var scroll = $(window).scrollTop();
        // console.log(scroll, "scroll");
        if (scroll >= 400) {
          $("product-form.db.productForm.mb30").removeClass("productFormabcd");
        } else {
          $("product-form.db.productForm.mb30").addClass("productFormabcd");
        }
      });
    }
  });
});

    var href = window.location.href; // Get the current URL
    var domainMatch = href.match(/\.(de|nl|com)(\/(nl|de|en))?/); // Match .de, .nl, .com, .com/nl, .com/de, .nl/en, .de/en
 if (domainMatch) {
        var domain = domainMatch[0]; // Extract the matched domain
    var text, imageSrc;

        // Conditions for Germany-related URLs (.de, .com/de, .nl/de, .de/de)
        if (domain === '.de' || domain === '.com/de' || domain === '.nl/de' || domain === '.de/de') {
           
            $('.kl-private-reset-css-Xuajs1').hide();
          // console.log('popup-hide')

          }
   
    }



// footer tabs open and close
$(document).ready(function() {
  // Hide all <ul> elements initially
  // $('.footer-links ul').hide();

  // // Handle click event on .footer-links
  // $('.footer-links').click(function() {
  //   // Hide all other <ul> elements except the one clicked
  //   $(this).siblings().find('ul').slideUp();

  //   // Toggle the visibility of the clicked <ul>
  //   $(this).find('ul').slideToggle();
  // });
});


// translation script for languagues 

// $(document).ready(function() {
//     var href = window.location.href; // Get the current URL
//     var domainMatch = href.match(/\.(de|nl|com)(\/(nl|de|en))?/); // Match .de, .nl, .com, .com/nl, .com/de, .nl/en, .de/en

//     if (domainMatch) {
//         var domain = domainMatch[0]; // Extract the matched domain
//         var text, imageSrc;

//         // Conditions for Germany-related URLs (.de, .com/de, .nl/de, .de/de)
//         if (domain === '.de' || domain === '.com/de' || domain === '.nl/de' || domain === '.de/de') {
//             text = 'Tippen Sie auf ein Gemälde, um zu wechseln'; // German text
//             $('.pop-up-btn span').text(text);

//             text = 'Sind Sie von dieser Fotowand begeistert, aber ein bestimmtes Gemälde spricht Sie nicht wirklich an? Kein Problem! Tippen Sie auf das Gemälde und ersetzen Sie es durch eines, das zu Ihnen passt!';
//             $('.product-button-description').text(text);
          
//             text = 'inkl. MwSt.';
//             $('span.incTax').text(text);

//             text = 'Bezahlen Sie sicher mit';
//             $('.fl1.paymentCall h4').text(text);
          
//             var text = '<b>Niederlande und Belgien:</b> Wenn Sie vor 16:00 Uhr bestellen, bereiten wir Ihre Bestellung sofort vor und Sie erhalten sie am nächsten Tag. <br><br>Ihre Bestellung wird versandkostenfrei geliefert!';
//             $('.tab-container .tab-content.tab-desp-1').html(text);

//             var text = 'Wir bieten ein 30-tägiges Rückgaberecht, wenn Sie aus irgendeinem Grund mit Ihrer Bestellung nicht zufrieden sind.';
//             $('.tab-container .tab-content.tab-desp-2').html(text);
          
//             // var divHtml1 = `<div class="imgWrap m_auto" style="max-width: 1076px; width: 60%;"><img class="imgFl ls-is-cached lazyloaded" loading="lazy" src="https://cdn.shopify.com/s/files/1/0827/3022/1911/files/Zahlung-v2-German.svg?v=1725535415" width="1076" height="111" alt=""></div>`
//             // $(".trust_badge.mb0.tc").prepend(divHtml1);
//             // // imageSrc = 'https://cdn.shopify.com/s/files/1/0827/3022/1911/files/Zahlung-v2-German.svg?v=1725535415';
//             // // $('.imgWrap.m_auto img').attr('src', imageSrc);
//             // $('.imgWrap.m_auto').css('width', '50%');

//             imageSrc = 'https://cdn.shopify.com/s/files/1/0827/3022/1911/files/Group_1.svg?v=1725610815';
//             $('.paymnet-img img').attr('src', imageSrc);

//   //         var divHtml = `
//   //   <div class="imgWrapper" style="max-width:1169px;">
//   //       <img class="custom__image imgFl lazyautosizes ls-is-cached lazyloaded" 
//   //           src="//collagedepot.com/cdn/shop/files/Trustpilot_Logo_sterren_50x.svg?v=1722943815" 
//   //           width="1169" height="561" 
//   //           data-srcset="//collagedepot.com/cdn/shop/files/Trustpilot_Logo_sterren_400x.svg?v=1722943815 400w,//collagedepot.com/cdn/shop/files/Trustpilot_Logo_sterren_700x.svg?v=1722943815 700w,//collagedepot.com/cdn/shop/files/Trustpilot_Logo_sterren_1000x.svg?v=1722943815 1000w,//collagedepot.com/cdn/shop/files/Trustpilot_Logo_sterren.svg?v=1722943815 1169w" 
//   //           data-sizes="auto" alt="" style="--ipos:;" sizes="125px" 
//   //           srcset="//collagedepot.com/cdn/shop/files/Trustpilot_Logo_sterren_400x.svg?v=1722943815 400w,//collagedepot.com/cdn/shop/files/Trustpilot_Logo_sterren_700x.svg?v=1722943815 700w,//collagedepot.com/cdn/shop/files/Trustpilot_Logo_sterren_1000x.svg?v=1722943815 1000w,//collagedepot.com/cdn/shop/files/Trustpilot_Logo_sterren.svg?v=1722943815 1169w">
//   //   </div>`;

//   // // Use prepend to add the new content before the custom-text div
//   // $(".ct-inner.of_hidden.ct-inner-text.wow.fadeIn .tc.f-asc").prepend(divHtml);

//         // Conditions for Dutch-related URLs (.de/nl, .nl, .com/nl, .nl/nl)
//         } else if (domain === '.de/nl' || domain === '.nl' || domain === '.com/nl' || domain === '.nl/nl' ) {
//             text = 'Tik op een schilderij om te verwisselen'; // Dutch text
//             console.log('Conditions for Dutch-related URLs');
//             $('.pop-up-btn span').text(text);

//             text = 'Ben je enthausiast over deze fotowand maar spreekt een bepaald schilderij jou niet helemaal aan? Geen probleem! Tik op het schilderij en vervang deze door een die helemaal bij jou past!';
//             $('.product-button-description').text(text);

//             imageSrc = 'https://collagedepot.nl/cdn/shop/files/Betalingsicoontjes-v2.svg?v=1722948400';
//             $('.imgWrap.m_auto img').attr('src', imageSrc);
//             $('.imgWrap.m_auto').css('width', '60%');

//             imageSrc = 'https://cdn.shopify.com/s/files/1/0827/3022/1911/files/Trustpilot.svg?v=1721667490';
//             $('.paymnet-img img').attr('src', imageSrc);

//         // Condition for .com (English version)
//         } else if (domain === '.com' || domain === '.de/en' || domain === '.nl/en' ) {
//             text = 'Tap on an artwork to switch'; // English text
//             console.log('Condition for .com (English version)');
//             $('.pop-up-btn span').text(text);

//             text = 'Are you excited about this photo wall but a certain painting doesnt quite appeal to you? No problem! Tap on the painting and replace it with one that suits you perfectly!';
//             $('.product-button-description').text(text);

//             text = 'Including VAT';
//             $('span.incTax').text(text);

//             text = 'Pay safely with';
//             $('.fl1.paymentCall h4').text(text);

//             // text = 'Black';
//             // $('.pvOpt1 label.swatchLbl.swatchLbl-1').text(text);

//             // text = 'Light Brown';
//             // $('.pvOpt1 label.swatchLbl.swatchLbl-3').text(text);
          
//             // text = 'Black';
//             // $('.pvOpt1 span.slVariant.ml5').text(text);
  
//             // $('.pvOpt1 .swatch-element input').change(function () {
//             //   var framename = $(this).next('label').text(); // Get the text of the label next to the input
//             //   console.log(framename);
//             //   $('.pvOpt1 .slVariant').text(framename); // Update the text in the target element
//             // });

//             // text = 'With';
//             // $('.pvOpt2 label.swatchLbl.swatchLbl-1').text(text);

//             // text = 'Without';
//             // $('.pvOpt2 label.swatchLbl.swatchLbl-2').text(text);

//             // text = 'With';
//             // $('.pvOpt2 span.slVariant.ml5').text(text);

//             // $('.pvOpt2 .swatch-element input').change(function () {
//             //   var framename = $(this).next('label').text(); // Get the text of the label next to the input
//             //   console.log(framename);
//             //   $('.pvOpt2 .slVariant').text(framename); // Update the text in the target element
//             // });

//             var text = '<b>Netherlands & Belgium:</b> If you order before 16:00, we will prepare your order immediately and you will receive it the next day. <br><br>Your order will be delivered free of charge!';
//             $('.tab-container .tab-content.tab-desp-1').html(text);

//             var text = 'We offer a 30-day return policy if you are not satisfied with your order for any reason.';
//             $('.tab-container .tab-content.tab-desp-2').html(text);

//             imageSrc = 'https://cdn.shopify.com/s/files/1/0827/3022/1911/files/Payment-v2-English.svg?v=1725539043';
//             $('.imgWrap.m_auto img').attr('src', imageSrc);
//             $('.imgWrap.m_auto').css('width', '50%');

//             imageSrc = 'https://cdn.shopify.com/s/files/1/0827/3022/1911/files/Group_1000001965.svg?v=1725551045';
//             $('.paymnet-img img').attr('src', imageSrc);
//         }
//     }
// });



// $(document).ready(function() {
//     // Track scroll direction: true means scrolling to the bottom, false means scrolling to the top
//     let scrollToBottom = true;

//     $(".arrow-image").click(function() {
//        $(".arrow-image").toggleClass("hide-arrow");
//         if (scrollToBottom) {
//             // Scroll to the bottom
//             var bottomPosition = $('.modal-content-Material')[0].scrollHeight;
//             $('.modal-content-Material').animate({
//                 scrollTop: bottomPosition
//             }, 300);
        
//         }
//         scrollToBottom = !scrollToBottom;
//     });

// });

function detectPlatform() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/android/i.test(userAgent)) {
    document.documentElement.classList.add('android-modal');
    document.body.classList.add('android-modal');
  } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    document.documentElement.classList.add('ios-modal');
    document.body.classList.add('ios-modal');
  }
}

detectPlatform();

 document.addEventListener('DOMContentLoaded', function() {
        // Get the dynamic time from Shopify settings
        var countdownTime = "{{ settings.countdown_time }}"; // Example: "48:00:00"
        // console.log("Countdown Time:", countdownTime);
    
        var timeParts = countdownTime.split(":");
        var hours = parseInt(timeParts[0], 10);
        var minutes = parseInt(timeParts[1], 10);
        var seconds = parseInt(timeParts[2], 10);
    
        // Validate parsed values
        if (isNaN(hours) || isNaN(minutes) || isNaN(seconds)) {
            console.error("Invalid countdown time provided. Please check the settings.");
            return;
        }
    
        // Calculate the countdown duration in milliseconds
        var countdownDuration = (hours * 60 * 60 * 1000) + (minutes * 60 * 1000) + (seconds * 1000);
        // console.log("Countdown Duration (ms):", countdownDuration);
    
        // Fixed start time (e.g., July 1, 2024, at 00:00:00 UTC)
        var fixedStartTime = new Date(Date.UTC(2024, 6, 1, 0, 0, 0)).getTime(); // July is month 6 (0-indexed)
        // console.log("Fixed Start Time (ms):", fixedStartTime);
    
        function getNextEndTime() {
            var now = new Date().getTime();
            var elapsedTime = now - fixedStartTime;
            var periodsElapsed = Math.floor(elapsedTime / countdownDuration);
            return fixedStartTime + ((periodsElapsed + 1) * countdownDuration);
        }
    
        var endTime = getNextEndTime();
        startCountdown(endTime);
     
        function startCountdown(endTime) {
            var countdownFunction = setInterval(function() {
              var now = new Date().getTime();
              var distance = endTime - now;
      
              var days = Math.floor(distance / (1000 * 60 * 60 * 24));
              var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
              var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
              var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      
              var daysStr = String(days).padStart(2, '0');
              var hoursStr = String(hours).padStart(2, '0');
              var minutesStr = String(minutes).padStart(2, '0');
              var secondsStr = String(seconds).padStart(2, '0');
      
              document.getElementById("countdownAbc").innerHTML = 
                  "<div class='days'><span>" + daysStr + "</span><span>d</span>" + "</div>" + 
                  "<div class='hours'><span>" + hoursStr + "</span><span>u</span>" + "</div>" + 
                  "<div class='minutes'><span>" + minutesStr + "</span><span>m</span>" + "</div>" + 
                  "<div class='seconds'><span>" + secondsStr + "</span><span>s</span>" + "</div>";
                    $('.countdownWrapper').removeClass('hidecounter');
              if (distance < 0) {
                  clearInterval(countdownFunction);
                  document.getElementById("countdownAbc").innerHTML = "EXPIRED";
                  endTime = getNextEndTime(); // Calculate the new end time
                  startCountdown(endTime); // Restart the countdown
              }
          }, 1000);
        }
      });
